// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import LocationAutocomplete from "components/layout/LocationAutocomplete";
import { UserpanelRow } from "containers/Userpanel/components/UserpanelRow";

// ** Styles

// #####################################################

const FakeLocation = ({ country, regionName, cityName }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	return (
		<UserpanelRow>
			<LocationAutocomplete
				location={{
					country,
					regionName,
					cityName,
					distance: 50,
				}}
				label={t("filtersAndSelectors:locationLabel")}
				withLabel
				onlyCities
				noPad
				noMaxWidth
				withGeolocation
				activatorOptions={{ withGeolocation: true }}
				notCleanInputInUseEffect={true}
			/>
		</UserpanelRow>
	);
};

// #####################################################

export default FakeLocation;

// #####################################################
